import {useSearchParams} from "react-router-dom";

const PaymentFailPage = () => {
    const [query] = useSearchParams()
    const message = query.get("message")

    if (message) {
        alert(`결제에 실패했습니다.\n사유: ${message}`)
        window.location.href = "/advanced/coupon"
    }
};

export default PaymentFailPage;